import { put, call, takeLatest, select } from 'redux-saga/effects'
import startOfDay from 'date-fns/startOfDay'
import subDays from 'date-fns/subDays'

import { companyId } from '@/core/selectors/sessions'

import * as hiringAnalyticsView from '../reducks/hiringAnalytics'
import { getNewCandidates } from '@/core/apiModules/hiringAnalytics'
import { errorHandler } from '@/core/helpers/errorHelpers'
import { showSystemError, hideSystemError } from '@/core/components/SystemErrorRedux'

function* fetchNewCandidates() {
  try {
    yield put(hideSystemError())

    const id = yield select(companyId)
    const response = yield call(getNewCandidates, id, { start_at: subDays(startOfDay(new Date()), 7) })
    yield put(hiringAnalyticsView.fetchNewCandidatesSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(hiringAnalyticsView.fetchNewCandidatesError(error))

    yield put(showSystemError(error))
  }
}

export default function* watchNewCandidatesSaga() {
  yield takeLatest(hiringAnalyticsView.FETCH_NEW_CANDIDATES, fetchNewCandidates)
}
